import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'SUPP_CLIENT',
  title: 'Comment supprimer un client ?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Vous êtes libre de supprimer une entreprise si vous ne souhaitez plus lui partager vos documents. Il vous suffit de suivre les étapes ci-dessous sur votre plateforme.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Rendez-vous sur l’onglet « Clients ».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SUPP_CLIENT/FR_SUPP_CLIENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez à droite sur les 3 points en face de votre client.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SUPP_CLIENT/FR_SUPP_CLIENT_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'En cliquant sur les 3 points, vous aurez la possibilité de supprimer l’entreprise.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SUPP_CLIENT/FR_SUPP_CLIENT_3.png`
  }]
};
